"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserData = void 0;
const react_1 = __importStar(require("react"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_apollo_1 = require("react-apollo");
const loggedContext_1 = require("../utils/loggedContext");
const server_types_1 = require("../server-types");
const userInfoQuery = (0, graphql_tag_1.default) `
	query UserDataQuery {
		currentUser {
			id
			localId
			firstName
			lastName
			langCode
			name
			email
			workEmail
			role
			status
			internalCapabilities
			socialType
			managedByUsers {
				id
				capabilities
				Company {
					id
					name
					billingBranch {
						id
						Country {
							id
							code
							name
						}
					}
				}
				Retailer {
					id
					name
					Country {
						id
						code
						name
					}
				}
				CompanyGroup {
					id
					name
				}
				Service {
					id
					name
				}
				GeoIndication {
					id
					name
				}
			}
		}
	}
`;
function isItalian(company) {
    return (company &&
        company.billingBranch &&
        company.billingBranch.Country &&
        company.billingBranch.Country.code === 'IT');
}
const UserData = ({ children }) => {
    const userKey = (0, react_1.useContext)(loggedContext_1.loggedContext);
    const notLogged = !userKey;
    return (react_1.default.createElement(react_apollo_1.Query, { query: userInfoQuery, errorPolicy: 'all', skip: notLogged }, ({ loading, data }) => {
        /**
         * NOTA BENE: la politica di gestione degli errori e' assente in quanto
         * un errore viene comunque considerato "utente non loggato"
         */
        const currentUser = data && data.currentUser;
        const internalCapabilities = !data || !currentUser ? [] : currentUser.internalCapabilities;
        const managed = (data &&
            currentUser?.managedByUsers?.filter((m) => {
                if (m && typeof m == 'object' && 'Company' in m) {
                    return !!m.Company;
                }
                return false;
            })[0]) ||
            undefined;
        const managedCapabilities = managed ? managed.capabilities : [];
        const capabilities = [
            ...internalCapabilities,
            ...managedCapabilities,
        ];
        const props = {
            loading,
            isLogged: !loading && !!data && !!currentUser,
            userData: currentUser,
            userIsBuyer: data && currentUser && currentUser.role === server_types_1.UserRole.Buyer,
            userHasCapability: (capability) => capabilities.includes(capability),
            capabilities,
            isInternal: currentUser && currentUser.role === server_types_1.UserRole.Internal,
            managedCompany: managed,
            managedCompanyIsItalian: (managed && isItalian(managed.Company)) || undefined,
        };
        return children(props);
    }));
};
exports.UserData = UserData;
//# sourceMappingURL=UserData.js.map